var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 19.1668C18.8951 19.1668 17.8353 18.7278 17.0539 17.9464C16.2725 17.165 15.8335 16.1052 15.8335 15.0002C15.8335 13.8951 16.2725 12.8353 17.0539 12.0539C17.8353 11.2725 18.8951 10.8335 20.0002 10.8335C21.1052 10.8335 22.165 11.2725 22.9464 12.0539C23.7278 12.8353 24.1668 13.8951 24.1668 15.0002C24.1668 15.5473 24.0591 16.0892 23.8497 16.5947C23.6403 17.1002 23.3334 17.5595 22.9464 17.9464C22.5595 18.3334 22.1002 18.6403 21.5947 18.8497C21.0892 19.0591 20.5473 19.1668 20.0002 19.1668ZM20.0002 3.3335C16.906 3.3335 13.9385 4.56266 11.7506 6.75058C9.56266 8.93851 8.3335 11.906 8.3335 15.0002C8.3335 23.7502 20.0002 36.6668 20.0002 36.6668C20.0002 36.6668 31.6668 23.7502 31.6668 15.0002C31.6668 11.906 30.4377 8.93851 28.2497 6.75058C26.0618 4.56266 23.0944 3.3335 20.0002 3.3335Z",
    fill: "#016AD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFilled);
export default __webpack_public_path__ + "static/media/PinFilled.79e07369c0592d8e3f58a7bb9f997185.svg";
export { ForwardRef as ReactComponent };